export default {
    state: () => ({
        previousPage: "/sales-board",
    }),
    getters: {
        getPreviousPage: (state) => {
            return state.previousPage;
        },
    },
    mutations: {
        setPreviousPage(state, data) {
            state.previousPage = data;
        },
    },
    namespaced: true,
};
